import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canClaimConversation } from 'components/conversation/utils/canClaimConversation';
import { canTakeOverConversation } from 'components/conversation/utils/canTakeOverConversation';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { LazyLoadedElevioResolveButton } from '../../integrations/elevio/src/components/ConversationResolution/LazyLoadedResolutionButton';
import { ConversationClaimButton } from './components/conversationClaimButton/conversationClaimButton';
import { ConversationCloseButton } from './components/conversationCloseButton/conversationCloseButton';
import { ConversationFollowUp } from './components/conversationFollowUp/conversationFollowUp';
import { ConversationTranslate } from './components/conversationTranslate/conversationTranslate';
import styles from './conversationActionBar.module.scss';
export const ConversationActionBar = () => {
    const { requester, conversation, isAssignedToMe, latestFacebookCsid } = useAppSelector((state) => ({
        requester: state.conversation.metaConversation.requester,
        conversation: state.conversation.metaConversation.conversation,
        isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
        latestFacebookCsid: getLatestFacebookConversation(state),
    }), shallowEqual);
    const flags = useFeatureFlag([
        'agent-copilot',
        'email-translation',
        'elevio-suggestions',
    ]);
    const canTranslate = useMemo(() => {
        const isEmailChannel = conversation.initial_channel === 'email' ||
            conversation.initial_channel === 'contactform';
        const isNonEmailTextualChannel = conversation.initial_channel === 'messenger' ||
            conversation.initial_channel === 'widgetchat' ||
            conversation.initial_channel === 'twitter' ||
            conversation.initial_channel === 'sms' ||
            conversation.initial_channel === 'facebookmessenger';
        if (isNonEmailTextualChannel && flags.agentCopilot) {
            return true;
        }
        if (isEmailChannel && flags.emailTranslation) {
            return true;
        }
        return false;
    }, [
        conversation.initial_channel,
        flags.agentCopilot,
        flags.emailTranslation,
    ]);
    const canClaim = (!!(requester === null || requester === void 0 ? void 0 : requester.anonymized_at) &&
        canTakeOverConversation(conversation, isAssignedToMe)) ||
        canClaimConversation(conversation, isAssignedToMe, latestFacebookCsid);
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [canTranslate && _jsx(ConversationTranslate, {}), _jsx(Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: flags.elevioSuggestions && _jsx(LazyLoadedElevioResolveButton, {}) })), _jsx(ConversationFollowUp, {}), canClaim ? _jsx(ConversationClaimButton, {}) : _jsx(ConversationCloseButton, {})] })));
};
